import { resolve } from '@/core/di';
import { TimelineApi } from './TimelineApi';

export { TimelineApi };
export const timelineApi = (): TimelineApi => resolve(TimelineApi);
